import { BlocksIconDownload } from 'blocks-nextjs/blocks-web-components/components/icon/icons/download';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconDownload = createComponent({ react: React, tagName: 'cat-icon-download', elementClass: BlocksIconDownload });
